import { useQuery } from "@apollo/client";
import {
  GetDeliveredEngagementSurveyQuery,
  GetDeliveredEngagementSurveyQueryVariables,
} from "types/graphql-schema";

import getDeliveredEngagementSurveyQuery from "@apps/engagement-survey/graphql/get-delivered-engagement-survey-query";
import {
  EngagementSurveyReportGraphQLFilters,
  EngagementSurveyReportViewOptions,
} from "@apps/reporting/components/engagement-survey-report/types";

const useSurveyDeliveryData = ({
  assessmentDeliveryId,
  viewOptions,
  filters,
  onCompleted,
}: {
  assessmentDeliveryId?: number;
  viewOptions: EngagementSurveyReportViewOptions;
  filters: EngagementSurveyReportGraphQLFilters;
  onCompleted?: (response: GetDeliveredEngagementSurveyQuery) => void;
}) => {
  const {
    teamIdsFilter,
    managerIdsFilter,
    managerIdsFullTreeFilter,
    employeeStartDateRangeFilter,
    locationsFilter,
  } = filters;

  const { data, loading, previousData } = useQuery<
    GetDeliveredEngagementSurveyQuery,
    GetDeliveredEngagementSurveyQueryVariables
  >(getDeliveredEngagementSurveyQuery, {
    fetchPolicy: "no-cache",
    skip: !assessmentDeliveryId,
    variables: {
      assessmentDeliveryId,
      teamIds: teamIdsFilter,
      managerIds: managerIdsFilter,
      managerIdsFullTree: managerIdsFullTreeFilter,
      employeeStartDateRange: employeeStartDateRangeFilter,
      locations: locationsFilter,
      groupBy: viewOptions.groupBy ?? undefined,
      collapsedKeys: viewOptions.hiddenColumns,
    },
    onCompleted,
  });

  return {
    assessmentDeliveryData: data,
    previousAssessmentDeliveryData: previousData,
    isLoadingAssessmentDelivery: loading,
  };
};

export default useSurveyDeliveryData;
